// Hooks
import { useAppSelector } from '../../../app/hooks';

// Features
import {
    selectSession,
    selectCurrentGame,
    selectSessionWinners,
} from '../../../features/session/sessionSlice';

// Components
import SessionScreen from '../../organisms/SessionScreen/SessionScreen';
import PatternWinners from '../../molecules/PatternWinners/PatternWinners';
import SessionIdle from '../../molecules/SessionIdle/SessionIdle';
import Leaderboard from '../../molecules/Leaderboard/Leaderboard';

/**
 * @function SessionScreen
 * Summary of previous game statistics
 *
 * @example
 * return (
 *   <GameWon />
 * )
 */
function GameWon(): JSX.Element {
    const session = useAppSelector(selectSession);
    const game = useAppSelector(selectCurrentGame);
    const { accumulatedWinners } = useAppSelector(selectSessionWinners);
    if (session === null || session === undefined) return <></>;
    const gameMeta = session?.games.find(({ id }) => id === game?.id);
    if (gameMeta === undefined) return <></>;
    const heading =
        session?.games.length > 1
            ? `Game ${gameMeta.sort_order} Over`
            : 'Game Over';

    return (
        <SessionScreen>
            <SessionIdle heading={heading}>
                {session?.session.tournament === true ? (
                    <Leaderboard
                        title="Session Progress"
                        winners={accumulatedWinners}
                    />
                ) : (
                    <PatternWinners
                        gameMeta={gameMeta}
                        winners={game.winners}
                    />
                )}
            </SessionIdle>
        </SessionScreen>
    );
}

// Exports
export default GameWon;
